import { Button, CircularProgress, Divider, FormControlLabel, FormLabel, Grid, Paper, Radio, Stack, Switch, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import PersonIcon from '@mui/icons-material/Person';
import { enqueueSnackbar } from 'notistack';
import InputStyle from '../../assets/InputStyle';
import InputStylefield from '../../assets/InputStylefield';
import { createJobDraft } from "../../actions/userAuth";
import { useDispatch } from "react-redux";
import Select from 'react-select'
import { useNavigate } from 'react-router-dom';
import { createJob } from '../../actions/userAuth';
import { Drafts, Edit } from '@mui/icons-material';
import { getJobById } from '../../actions/userAuth';
import { useEffect } from 'react';
import { updateJob } from '../../actions/userAuth';
import { State, City, Country } from 'country-state-city';

const EditJobForm = ({ id }) => {
    const [logoFile, setLogoFile] = useState([]);
    const [companyName, setCompanyName] = useState("");
    const [jobTitle, setJobTitle] = useState("");
    const [jobType, setJobType] = useState("");
    const [gender, setGender] = useState("");
    const [expiryDate, setExpiryDate] = useState("");
    const [currency, setCurrency] = useState("");
    const [salaryPeriod, setSalaryPeriod] = useState("");
    const [salaryRangeFrom, setSalaryRangeFrom] = useState("");
    const [salaryRangeTo, setSalaryRangeTo] = useState("");
    const [careerLevel, setCareerLevel] = useState("");
    const [jobShift, setJobShift] = useState("");
    const [qualification, setQualification] = useState("");
    const [experience, setExperience] = useState("");
    const [website, setWebsite] = useState("");
    const [applyThroughWebsite, setApplyThroughWebsite] = useState("");
    const [showEmail, setShowEmail] = useState("");
    const [showPhone, setShowPhone] = useState("");
    const [hideSalary, setHideSalary] = useState("");
    const [jobCategory, setJobCategory] = useState("");
    const [openings, setOpenings] = useState("");
    const [loading, setLoading] = useState(false);
    const [country, setCountry] = useState([]);
    const [states, setStates] = useState(State.getStatesOfCountry(''));
    const [selectedState, setSelectedState] = useState('');
    const [selectedCountry, setSelectedCountry] = useState('');
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState('');


    const dispatch = useDispatch()

    useEffect(() => {
        setCountry(Country.getAllCountries())
    }, [])

    const handleChangeCountry = (e) => {
        setSelectedCountry(Country.getCountryByCode(e.target.value))
        setStates(State.getStatesOfCountry(e.target.value))
    }


    const handleChangeState = (e) => {
        setCities(City.getCitiesOfState(selectedCountry.isoCode, e.target.value));
        setSelectedState(State.getStateByCodeAndCountry(e.target.value, selectedCountry.isoCode).name);
    };

    const handleChangeCity = (e) => {

        setSelectedCity(e.target.value);
    };




    useEffect(() => {
        dispatch(getJobById({ id }, (data) => {

            // setJobs(data.data.data);
            setCompanyName(data.data.companyName)
            // setLogoFile(data.data.logoUrl)
            setJobTitle(data.data.jobTitle)
            setJobType(data.data.jobType)
            setSelectedCountry(Country.getAllCountries().filter((x) => x.name == data.data.country)[0])
            setStates(State.getStatesOfCountry(Country.getAllCountries().filter((x) => x.name == data.data.country)[0].isoCode))
            setSelectedState(State.getAllStates().filter(x => x.name == data.data.state)[0])
            setCities(City.getCitiesOfState(Country.getAllCountries().filter((x) => x.name == data.data.country)[0].isoCode, State.getAllStates().filter(x => x.name == data.data.state)[0].isoCode));
            setSelectedCity(City.getCitiesOfState(Country.getAllCountries().filter((x) => x.name == data.data.country)[0].isoCode, State.getAllStates().filter(x => x.name == data.data.state)[0].isoCode).filter(x => x.name == data.data.city)[0].name);
            setGender(data.data.genderPreference)
            setExpiryDate(data.data.jobExpiryDate)
            setCurrency(data.data.currency)
            setSalaryPeriod(data.data.salaryPeriod)
            setSalaryRangeFrom(data.data.salaryRangeFrom)
            setSalaryRangeTo(data.data.salaryRangeTo)
            setCareerLevel(data.data.careerLevel)
            setJobShift(data.data.jobShift)
            setQualification(data.data.qualification)
            setExperience(data.data.jobExperience)
            setWebsite(data.data.companyWebsite)
            setApplyThroughWebsite(data.data.applyThroughWebsite)
            setShowEmail(data.data.showEmailAddress)
            setShowPhone(data.data.showPhoneNumber)
            setHideSalary(data.data.hideSalary)
            // setJobCategory()
            // setOpenings()
        }, (err) => {
            console.log(err);
        },
        ))
    }, []);


    const handleRelocationChange = (event) => {
        setApplyThroughWebsite(event.target.value);
    };

    const handleSwitchOneChange = () => {
        setShowEmail(!showEmail);
    };

    const handleSwitchTwoChange = () => {
        setShowPhone(!showPhone);
    };

    const handleSwitchThreeChange = () => {
        setHideSalary(!hideSalary);
    };

    const handleCompanyLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        setLogoFile(file);
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        }
    }

    const colourOptions = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ]

    const handleSubmit = () => {
        setLoading(true);
        let payload = {
            logoUrl: logoFile,
            companyName: companyName,
            jobTitle: jobTitle,
            jobType: jobType,
            jobStatus: '',
            status: 'open',
            isActiv: '',
            country: selectedCountry.name,
            state: selectedState,
            city: selectedCity,
            jobDescription: '',
            genderPreference: '',
            jobExpiryDate: '',
            currency: currency,
            salaryPeriod: salaryPeriod,
            salaryRangeFrom: salaryRangeFrom,
            salaryRangeTo: salaryRangeTo,
            supplementalPay: '',
            benefitsOffered: '',
            skills: '',
            keywords: '',
            careerLevel: careerLevel,
            jobShift: jobShift,
            qualification: qualification,
            jobExperience: experience,
            applyThroughWebsite: applyThroughWebsite,
            companyWebsite: website,
            showEmailAddress: showEmail,
            showPhoneNumber: showPhone,
            hideSalary: hideSalary
        }
        console.log("Here is Payload", payload);
        dispatch(
            updateJob(id, { payload }, (data) => {
                console.log("Here is Data:", data);
                setLoading(false);
                enqueueSnackbar("Job updated success fully", {variant: 'success'});
                navigate('/employer/job-status');
            })
        );

    }

    const navigate = useNavigate();

    return (
        <>
            <Paper sx={{ py: 3 }}>
                <Box px={{ md: 5, xs: 3 }} py={3}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Edit Job</Typography>
                    <Divider sx={{ backgroundColor: '#d2d2d2', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                </Box>

                <Box sx={{ display: 'flex' }}>
                    <Stack py={2} mx={{ md: 5, xs: 3 }} my={2} sx={{ backgroundColor: '#3665D014', alignItems: 'center', justifyContent: 'center', borderRadius: '10px', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                        {
                            logoFile != ""
                                ?
                                <img
                                    src={URL.createObjectURL(logoFile)}
                                    style={{ width: '100px', height: '100px', objectFit: 'contain', textTransform: 'none' }}
                                />
                                :
                                <PersonIcon sx={{ color: '#fff', fontSize: '5rem', color: '#2544EE' }} />
                        }
                        <Button
                            variant="contained"
                            component="label"
                            my={3}
                            sx={{
                                fontSize: '8px',
                                backgroundColor: '#2544EE',
                                textTransform: 'none',
                                mx: 2,
                                '@media (max-width: 600px)': {
                                    width: '100%', // Set width to 100% on smaller screens
                                },
                            }}
                        >
                            Upload Company Logo
                            <input
                                onChange={handleCompanyLogoUpload}
                                type="file"
                                accept=".jpg,.png"
                                hidden
                                required
                            />
                        </Button>

                    </Stack>
                    <Typography variant='body1' my={2} sx={{ fontSize: "12px" }} >Profile Image :- Max file size is 1MB, Minimum dimension: 136 x 136 And Suitable files are .jpg & .png</Typography>
                </Box>

                <Grid container spacing={3} px={{ md: 4, xs: 3 }}>
                    <Grid item xs={12} md={8}>
                        <InputStylefield name="Company Name" topSpace={true}>
                            <input
                                value={companyName}
                                type="text"
                                placeholder="Enter Short name of Company like TCS, ITC, etc"
                                onChange={(e) => setCompanyName(e.target.value)}
                            />
                        </InputStylefield>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <InputStylefield name="Job Title" topSpace={true}>
                            <input
                                value={jobTitle}
                                type="text"
                                placeholder="Enter your job title"
                                onChange={(e) => setJobTitle(e.target.value)}
                            />
                        </InputStylefield>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <InputStylefield name="Job Type" topSpace={true}>
                            <select
                                className="profile-skills-box"
                                type="text"
                                placeholder="Select Team Size"
                                list="Type"
                                value={jobType}
                                onChange={(e) => setJobType(e.target.value)}
                            >
                                <option value="">Select</option>
                                <option value="Full Time">Full Time</option>
                                <option value="Part Time">Part Time</option>
                                <option value="Internship">Internship</option>
                            </select>
                        </InputStylefield>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <InputStylefield name="Job Category" topSpace={true}>
                            <select
                                className="profile-skills-box"
                                type="text"
                                placeholder="Select Team Size"
                                list="Type"
                                value={jobCategory}
                                onChange={(e) => setJobCategory(e.target.value)}
                            >
                                <option value="">Select</option>
                                <option value="Full Time">Full Time</option>
                                <option value="Part Time">Part Time</option>
                                <option value="Internship">Internship</option>
                            </select>
                        </InputStylefield>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <InputStylefield name="Number of Job Opening" topSpace={true}>
                            <input
                                value={openings}
                                placeholder="Enter number of openings"
                                onChange={(e) => setOpenings(e.target.value)}
                            />
                        </InputStylefield>
                    </Grid>
                </Grid>

                <Grid container spacing={3} px={4}>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputStylefield name="Country" topSpace={true}>
                            <select
                                className="profile-skills-box"
                                type="text"
                                placeholder="Select Country"
                                list="Type"
                                value={selectedCountry?.isoCode}
                                onChange={handleChangeCountry}
                            >
                                <option value="">Select</option>
                                {country.map((item, index) => (
                                    <option key={index} value={item.isoCode}>{item.name}</option>
                                ))}
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <InputStylefield name="State" topSpace={true}>
                            <select
                                className="profile-skills-box"
                                type="text"
                                placeholder="Select State"
                                list="Type"
                                defaultValue={"selectCity"}
                                disabled={selectedCountry == ""}
                                value={selectedState?.isoCode}
                                id="selectState"
                                onChange={handleChangeState}

                            >
                                <option value="">Select</option>
                                {states.map((item, index) => (
                                    <option key={index} value={item.isoCode}>{item.name}</option>
                                ))}
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <InputStylefield name="City" topSpace={true}>
                            <select
                                className="profile-skills-box"
                                type="text"
                                placeholder="Select City"
                                list="Type"
                                disabled={selectedState == ""}
                                id="selectCity"
                                value={selectedCity}
                                onChange={handleChangeCity}
                            >
                                <option value="">Select</option>
                                {cities.map((item, index) => (
                                    <option key={index} value={item.name} > {item.name}</option>
                                ))}
                            </select>
                        </InputStylefield>
                    </Grid>
                </Grid>

                <Grid container spacing={3} px={4}>
                    <Grid item md={6} xs={12} >
                        <InputStylefield name="Gender " topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12} >
                        <InputStylefield name="Job expiry Date " topSpace={true}>
                            <input
                                value={expiryDate}
                                type="date"
                                placeholder="job expiry date"
                                onChange={(e) => setExpiryDate(e.target.value)}
                            />
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Currency" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={currency}
                                onChange={(e) => setCurrency(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12} >
                        <InputStylefield name="Salary Period" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={salaryPeriod}
                                onChange={(e) => setSalaryPeriod(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12} >
                        <InputStylefield name="Salary Range From" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={salaryRangeFrom}
                                onChange={(e) => setSalaryRangeFrom(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Salary Range To" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={salaryRangeTo}
                                onChange={(e) => setSalaryRangeTo(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Do you offer any of the supplemental pay?" topSpace={true}>
                            <Select
                                style={{ height: '10rem' }}
                                defaultValue={[colourOptions[2], colourOptions[3]]}
                                isMulti
                                name="colors"
                                options={colourOptions}
                                className="basic-multi-select"
                                classNamePrefix="select"
                            />
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Are any of the Following benefits offered?" topSpace={true}>
                            <Select
                                style={{ height: '10rem' }}
                                defaultValue={[colourOptions[2], colourOptions[3]]}
                                isMulti
                                name="colors"
                                options={colourOptions}
                                className="basic-multi-select"
                                classNamePrefix="select"
                            />
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Skills" topSpace={true}>
                            <Select
                                style={{ height: '10rem' }}
                                defaultValue={[colourOptions[2], colourOptions[3]]}
                                isMulti
                                name="skills"
                                options={colourOptions}
                                className="basic-multi-select"
                                classNamePrefix="select"
                            />
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Keywords" topSpace={true}>
                            <Select
                                style={{ height: '10rem' }}
                                defaultValue={[colourOptions[2], colourOptions[3]]}
                                isMulti
                                name="skills"
                                options={colourOptions}
                                className="basic-multi-select"
                                classNamePrefix="select"
                            />
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Career Level" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={careerLevel}
                                onChange={(e) => setCareerLevel(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Job Shift" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={jobShift}
                                onChange={(e) => setJobShift(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Qualification" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={qualification}
                                onChange={(e) => setQualification(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Job Experience" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={experience}
                                onChange={(e) => setExperience(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Salary Range To" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={salaryRangeTo}
                                onChange={(e) => setSalaryRangeTo(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <InputStylefield name="Salary Range To" topSpace={true}>
                            <select className="profile-skills-box" type="text" placeholder="Select Team Size"
                                list="Type"
                                value={salaryRangeTo}
                                onChange={(e) => setSalaryRangeTo(e.target.value)}>
                                <option value="">Select </option>
                                <option value="Male">Rupee</option>
                                <option value="Female">Dollar</option>
                                <option value="Other">Riyal</option>
                            </select>
                        </InputStylefield>
                    </Grid>

                    <Grid item md={6} >
                        <FormLabel sx={{ color: '#000' }} className="text2Bold">Apply through Company Website </FormLabel>
                        <br />
                        <FormControlLabel value="Yes" control={<Radio
                            checked={applyThroughWebsite === 'Yes'}
                            onChange={handleRelocationChange}
                            value="Yes"
                            name="radio-buttons"
                            inputProps={{ 'aria-label': 'Yes' }}
                        />} label="Yes" />
                        <br />
                        <FormControlLabel value="No" control={<Radio
                            checked={applyThroughWebsite === 'No'}
                            onChange={handleRelocationChange}
                            value="No"
                            name="radio-buttons"
                            inputProps={{ 'aria-label': 'No' }}
                        />} label="No" />
                    </Grid>

                    <Grid item md={6} >
                        <div>
                            <Box sx={{ display: 'flex', alignItems: 'center', verticalAlign: 'middle' }}>
                                <Typography variant="body2" className='text2Bold'>Want to Show Your Email Address on Job description Page?</Typography>
                                <Switch
                                    checked={showEmail}
                                    onChange={handleSwitchOneChange}
                                    style={{ color: '#2544EE' }}
                                    inputProps={{ 'aria-label': 'switch one' }}
                                />
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center', verticalAlign: 'middle' }}>
                                <Typography variant="body2" className='text2Bold'>Want to Show Your  Phone Number on Job description Page?</Typography>
                                <Switch
                                    checked={showPhone}
                                    onChange={handleSwitchTwoChange}
                                    style={{ color: '#2544EE' }}
                                    inputProps={{ 'aria-label': 'switch two' }}
                                />
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center', verticalAlign: 'middle', width: '100%' }}>
                                <Typography variant="body2" className='text2Bold'>Want to Hide Salary on Description page?</Typography>
                                <Switch
                                    checked={hideSalary}
                                    onChange={handleSwitchThreeChange}
                                    style={{ color: '#2544EE' }}
                                    inputProps={{ 'aria-label': 'switch three' }}
                                />
                            </Box>
                        </div>
                    </Grid>

                    <Grid item md={6} xs={12} >
                        <InputStylefield name="Company Website" topSpace={true}>
                            <input
                                value={website}
                                type="text"
                                placeholder="Enter your job title"
                                onChange={(e) => setWebsite(e.target.value)}
                            />
                        </InputStylefield>
                    </Grid>
                </Grid>

                <Grid sx={{ display: 'flex', flexDirection: { md: 'row', xs: 'column' }, my: 4, mx: 3, gap: { md: 0, xs: 2 } }}>
                    <Grid item xs={12} sm={6}>
                        <Button
                            sx={{
                                mx: { md: 3, xs: 0 },
                                backgroundColor: '#2544EE',
                                borderRadius: '2rem',
                                color: '#fff',
                                border: '1px solid #2544EE',
                                '&:hover': {
                                    color: '#2544EE',
                                    backgroundColor: '#F7FAFF'
                                },
                                textTransform: 'none',
                                width: '100%', // Set the width to 100% to occupy the available space
                                '@media (min-width: 600px)': {
                                    width: 'auto', // Reset width to auto on larger screens
                                },
                            }}
                            disabled={loading}
                            onClick={handleSubmit}
                            variant="contained"
                        >
                            {loading ? (
                                <CircularProgress size={24} />
                            ) : (
                                "Update Job"
                            )}
                        </Button>
                    </Grid>

                    {/* <Grid item xs={12} sm={6}>
                        <Button
                            sx={{
                                mx:{md:3, xs:0},
                                backgroundColor: '#F7FAFF',
                                borderRadius: '2rem',
                                color: '#2544EE',
                                border: '1px solid #2544EE',
                                '&:hover': {
                                    color: '#fff',
                                    backgroundColor: '#2544EE'
                                },
                                textTransform: 'none',
                                width: '100%', // Set the width to 100% to occupy the available space
                                '@media (min-width: 600px)': {
                                    width: 'auto', // Reset width to auto on larger screens
                                },
                            }}
                            onClick={() => navigate('/employer/job-preview')}
                            variant="contained"
                        >
                            Preview Job
                        </Button>
                    </Grid> */}



                    <Grid item xs={12} md={6}>


                        <Button sx={{
                            mx: { md: 3, xs: 0 },
                            backgroundColor: '#F7FAFF',
                            borderRadius: '2rem',
                            color: '#2544EE',
                            border: '1px solid #2544EE',
                            '&:hover': {
                                color: '#fff',
                                backgroundColor: '#2544EE'
                            },
                            textTransform: 'none',
                            width: '100%', // Set the width to 100% to occupy the available space
                            '@media (min-width: 600px)': {
                                width: 'auto', // Reset width to auto on larger screens
                            },
                        }}
                            onClick={() => navigate('/')}
                            variant="contained">
                            Cancel
                        </Button>
                    </Grid>

                </Grid>

            </Paper>
        </>
    )
}
export default EditJobForm;